module.exports = __webpack_public_path__ + "static/media/laas-s.dbf8edb5.mp3";